// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MahD","toggle":"styles_toggle__2qk7-","preview":"styles_preview__17d_3"};